import styles from "@components/__templates__/CommonSuccessPage/CommonSuccessPage.module.scss";
import Grid from "@components/Grid/Grid";
import Link from "@components/Link/Link";
import clsx from "clsx";
import { marked } from "marked";
import { useRouter } from "next/router";
import { useEffect, useRef } from "react";

export interface CommonSuccessPageProps {
  successHeaderTitleText: string;
  successDescriptionText: string;
  downloadBrochureLinkText: string;
  returnToPreviousPageLinkText: string;
  verifyEmailText: string;
}

const CommonSuccessPage = (props: { content: CommonSuccessPageProps }) => {
  const { content } = props;
  const {
    successHeaderTitleText,
    successDescriptionText,
    downloadBrochureLinkText,
    verifyEmailText,
    returnToPreviousPageLinkText,
  } = content;

  const router = useRouter();
  const successRef = useRef(null);

  const isWindow = typeof window === "object";
  const urlParams = isWindow
    ? new URLSearchParams(window.location.search)
    : null;
  const returnToPreviousPageUrl = urlParams?.get("returnToPreviousPageUrl");
  const downloadBrochureUrl = urlParams?.get("downloadBrochureUrl");
  const eventName = urlParams?.get("eventName");
  const status = urlParams?.get("status");

  useEffect(() => {
    if (successRef.current) {
      successRef.current.focus();
    }
  }, []);

  const returnToOriginalPage = () => {
    router.push(`${returnToPreviousPageUrl}`, undefined, {
      shallow: true,
    });
  };

  return (
    <div className="component-wrap">
      <Grid row>
        <Grid column sm={12}>
          <div className={clsx("component", styles["success-common"])}>
            <div className="wrapper">
              <Grid row>
                <Grid column sm={12} md={12} lg={12}>
                  <h1
                    className={clsx(styles["section-title"], styles.h2)}
                    tabIndex={-1}
                    ref={successRef}
                  >
                    {successHeaderTitleText} {eventName}
                  </h1>
                  <div
                    className={styles["success-text"]}
                    dangerouslySetInnerHTML={{
                      __html: marked.parse(
                        successDescriptionText || ""
                      ) as string,
                    }}
                  />
                  {status === "verification" && (
                    <div className={styles["success-text"]}>
                      <p>{verifyEmailText}</p>
                    </div>
                  )}
                </Grid>
              </Grid>
            </div>
            <div className={clsx(styles["links-wrapper"])}>
              <div className="wrapper">
                <Grid row>
                  <Grid column sm={12} md={12} lg={12}>
                    <div className={styles["userLink-section"]}>
                      {downloadBrochureUrl && (
                        <p>
                          <a
                            href={`${downloadBrochureUrl}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {downloadBrochureLinkText}
                          </a>
                        </p>
                      )}

                      {returnToPreviousPageUrl && (
                        <p>
                          <Link
                            href={`${returnToPreviousPageUrl}`}
                            onClick={returnToOriginalPage}
                          >
                            {returnToPreviousPageLinkText}
                          </Link>
                        </p>
                      )}
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default CommonSuccessPage;
